@if (feed.CardType === cardTypes.Trivia || feed.CardType === cardTypes.Predictor) {
  <div class="feed-item">
    <div class="feed feed-games">
      <img
        class="feed-game-image"
        alt=""
        fgbImgPreload
        [dataSrc]="feed.Data.Image"
        [imgOptions]="{ variantId: '1', loyaltyType: 'marketplace' }"
      />
      <div class="d-flex justify-content-between mb-2">
        <span class="feed-game-title">
          {{ (feed.CardType === cardTypes.Trivia ? 'fgbcl.feed.trivia.title' : 'fgbcl.feed.predictor.title') | translate }}
        </span>
        <fgbcl-countdown-v2 class="font-size-12" [endDateTime]="feed?.Data.EndDate"></fgbcl-countdown-v2>
      </div>
      <h5 class="feed-title">{{ feed?.Data.Title }}</h5>
      <div class="action-wrapper">
        <button (click)="openModal(feed?.Data?.Id)" class="btn fw-bold">
          {{ (feed.CardType === cardTypes.Trivia ? 'fgbcl.feed.trivia.button' : 'fgbcl.feed.predictor.button') | translate }}
        </button>
      </div>
      @if (feed?.Data?.Sponsor?.SponsorImage) {
        <div class="feed-sponsor-section">
          <div class="feed-sponsor-text">{{ feed?.Data?.Sponsor?.SponsorText }}:</div>
          <a
            [attr.href]="feed?.Data?.Sponsor?.SponsorLink || null"
            [attr.target]="feed?.Data?.Sponsor?.SponsorLink ? '_blank' : null"
            [attr.rel]="feed?.Data?.Sponsor?.SponsorLink ? 'noopener noreferrer' : null"
          >
            <img class="feed-sponsor-image" [src]="feed?.Data?.Sponsor?.SponsorImage | contentImage: '1'" />
          </a>
        </div>
      }
    </div>
  </div>
}

<!-- Trivia Modal -->
<ng-template #triviaContent let-modal>
  @if (gameGroup) {
    <fgbcl-games-list-modal
      [predictorStatus]="''"
      [gameGroup]="gameGroup"
      [groupType]="groupTypes.Trivia"
      (closeModal)="closeModal()"
    ></fgbcl-games-list-modal>
  }
</ng-template>

<!-- Predictor Modal -->
<ng-template #predictorContent let-modal>
  @if (gameGroup) {
    <fgbcl-games-list-modal
      [predictorStatus]="gamesGroupQuery.getPredictorFinalStatus(gameGroup).value"
      [gameGroup]="gameGroup"
      [groupType]="groupTypes.Predictor"
      (closeModal)="closeModal()"
    ></fgbcl-games-list-modal>
  }
</ng-template>
